import { DeviceManifest } from '@rapoo/device-sdk'
import {
  dpi60kStep1,
  mouseMacro,
  mousePerfCap,
  parametersLiftoffLow,
  retailMouseConfig,
} from './generate/capabilityPresets'

/**
 * VT9 MAX MASTER V2 设备清单
 **/
const rapooVT9MAXMASTERV2: DeviceManifest = {
  channel: ['china_game', 'global'],
  model: 'VT9 MAX MASTER V2',
  mainControl: 'VT9 MAX MASTER V2',
  dongleModel: 'Dongle_NordicH20',
  type: 'mouse',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4673, 0x1473],
    currentPid: 0x4673,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 14,
        description: 'Only update Firmware',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Only update WCH Firmware',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L',
  MCU: 'N54H20',
  sensor: 'PAW3955U',
  microSwitch: 'optical',
  encoder: 'optical',
  battery: 800,
  ui: {
    assetsDir: 'manifests/VT9 MAX MASTER V2',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.VT9_MAX_MASTER_V2.Metallic_Iridescent',
          value: ['#575593', '#7DBFE1'],
          key: 'Metallic_Iridescent',
        },
      ],
      current: 'Metallic_Iridescent',
    },
    // 小图�?
    icon: 'Hardware-Wireframe-Mouse',
    // 是否支持设备概览
    overview: true,
  },
  capabilities: [
    retailMouseConfig,
    parametersLiftoffLow,
    dpi60kStep1,
    mouseMacro,
    mousePerfCap({
      tier: 'retail',
      sensorScanRateLabel: '13K',
      keyScanRate: true,
      rfPacketType: 'always',
    }),
  ],
  layout: {
    keys: [
      [
        {
          key: 0,
          keywords: '左击',
          x: -25,
          y: 50,
          alignLeft: false,
          url: 'mouse left',
        },
        {
          key: 1,
          keywords: '中键',
          x: 240,
          y: 52,
          alignLeft: true,
          url: 'roller middle',
        },
        {
          key: 2,
          keywords: '右击',
          x: 240,
          y: 156,
          alignLeft: true,
          url: 'mouse right',
        },
        {
          key: 3,
          keywords: 'DPI+',
          x: 240,
          y: 208,
          alignLeft: true,
          url: 'dpi+',
        },
        {
          key: 4,
          keywords: 'DPI-',
          x: 240,
          y: 260,
          alignLeft: true,
          url: 'dpi-',
        },
        {
          key: 5,
          keywords: '右侧',
          x: -25,
          y: 132,
          alignLeft: false,
          url: 'mouse forward',
        },
        {
          key: 6,
          keywords: '左侧',
          x: -25,
          y: 195,
          alignLeft: false,
          url: 'mouse back',
        },
        {
          key: 9,
          keywords: '上滚',
          x: 240,
          y: 0,
          alignLeft: true,
          url: 'roller up',
        },
        {
          key: 10,
          keywords: '下滚',
          x: 240,
          y: 104,
          alignLeft: true,
          url: 'roller down',
        },
        {
          key: 13,
          keywords: 'DIY',
          x: 655,
          y: 118,
          alignLeft: true,
          url: 'diy',
        },
      ],
    ],
  },
}

export default rapooVT9MAXMASTERV2
